import React from 'react';

interface StudioMarkProps {
  size?: number | string;
  color?: string;
}

const markStyle: React.CSSProperties = {
  display: 'block',
  flexShrink: 0
};

export const StudioStarMark: React.FC<StudioMarkProps> = ({ size = '1em', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill={color} aria-hidden="true" style={markStyle}>
    <path d="M6 .6l1.18 3.98L11.4 6 7.18 7.42 6 11.4 4.82 7.42.6 6l4.22-1.42z" />
  </svg>
);

export const StudioDiamondMark: React.FC<StudioMarkProps> = ({ size = '1em', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill={color} aria-hidden="true" style={markStyle}>
    <path d="M6 .9 11.1 6 6 11.1.9 6z" />
  </svg>
);
